exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, "import 'video.js/dist/video-js.css'[data-v-2c0bb5a9],\n.youtube-player[data-v-2c0bb5a9] {\n  opacity: 0;\n}\nimport 'video.js/dist/video-js.css'.ready[data-v-2c0bb5a9],\n.youtube-player.ready[data-v-2c0bb5a9] {\n  opacity: 100;\n}\nimport 'video.js/dist/video-js.css' video[data-v-2c0bb5a9],\n.youtube-player video[data-v-2c0bb5a9] {\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n}\n", ""]);

// exports
